/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  OkResponse,
  SupportListTicketsParams,
  SupportMessage,
  SupportMessageCreateRequest,
  SupportTicket,
  SupportTicketCreateRequest,
  SupportTicketUpdateRequest
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Create support ticket
 */
export const supportCreateTicket = (
    supportTicketCreateRequest: SupportTicketCreateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SupportTicket>(
      {url: `/api/support/tickets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: supportTicketCreateRequest, signal
    },
      options);
    }
  


export const getSupportCreateTicketMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportCreateTicket>>, TError,{data: SupportTicketCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof supportCreateTicket>>, TError,{data: SupportTicketCreateRequest}, TContext> => {

const mutationKey = ['supportCreateTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportCreateTicket>>, {data: SupportTicketCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  supportCreateTicket(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportCreateTicketMutationResult = NonNullable<Awaited<ReturnType<typeof supportCreateTicket>>>
    export type SupportCreateTicketMutationBody = SupportTicketCreateRequest
    export type SupportCreateTicketMutationError = ErrorResponse

    /**
 * @summary Create support ticket
 */
export const useSupportCreateTicket = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportCreateTicket>>, TError,{data: SupportTicketCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportCreateTicket>>,
        TError,
        {data: SupportTicketCreateRequest},
        TContext
      > => {

      const mutationOptions = getSupportCreateTicketMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List support tickets
 */
export const supportListTickets = (
    params?: SupportListTicketsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SupportTicket[]>(
      {url: `/api/support/tickets`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSupportListTicketsQueryKey = (params?: SupportListTicketsParams,) => {
    return [
    `/api/support/tickets`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSupportListTicketsQueryOptions = <TData = Awaited<ReturnType<typeof supportListTickets>>, TError = ErrorResponse>(params?: SupportListTicketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListTickets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportListTicketsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportListTickets>>> = ({ signal }) => supportListTickets(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportListTickets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportListTicketsQueryResult = NonNullable<Awaited<ReturnType<typeof supportListTickets>>>
export type SupportListTicketsQueryError = ErrorResponse


export function useSupportListTickets<TData = Awaited<ReturnType<typeof supportListTickets>>, TError = ErrorResponse>(
 params: undefined |  SupportListTicketsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListTickets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportListTickets>>,
          TError,
          Awaited<ReturnType<typeof supportListTickets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportListTickets<TData = Awaited<ReturnType<typeof supportListTickets>>, TError = ErrorResponse>(
 params?: SupportListTicketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListTickets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportListTickets>>,
          TError,
          Awaited<ReturnType<typeof supportListTickets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportListTickets<TData = Awaited<ReturnType<typeof supportListTickets>>, TError = ErrorResponse>(
 params?: SupportListTicketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListTickets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List support tickets
 */

export function useSupportListTickets<TData = Awaited<ReturnType<typeof supportListTickets>>, TError = ErrorResponse>(
 params?: SupportListTicketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListTickets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportListTicketsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get support ticket
 */
export const supportGetTicket = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SupportTicket>(
      {url: `/api/support/tickets/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getSupportGetTicketQueryKey = (id?: string,) => {
    return [
    `/api/support/tickets/${id}`
    ] as const;
    }

    
export const getSupportGetTicketQueryOptions = <TData = Awaited<ReturnType<typeof supportGetTicket>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportGetTicket>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportGetTicketQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportGetTicket>>> = ({ signal }) => supportGetTicket(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportGetTicket>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportGetTicketQueryResult = NonNullable<Awaited<ReturnType<typeof supportGetTicket>>>
export type SupportGetTicketQueryError = ErrorResponse


export function useSupportGetTicket<TData = Awaited<ReturnType<typeof supportGetTicket>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportGetTicket>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportGetTicket>>,
          TError,
          Awaited<ReturnType<typeof supportGetTicket>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportGetTicket<TData = Awaited<ReturnType<typeof supportGetTicket>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportGetTicket>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportGetTicket>>,
          TError,
          Awaited<ReturnType<typeof supportGetTicket>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportGetTicket<TData = Awaited<ReturnType<typeof supportGetTicket>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportGetTicket>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get support ticket
 */

export function useSupportGetTicket<TData = Awaited<ReturnType<typeof supportGetTicket>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportGetTicket>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportGetTicketQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Send support message
 */
export const supportSendMessage = (
    id: string,
    supportMessageCreateRequest: SupportMessageCreateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SupportMessage>(
      {url: `/api/support/tickets/${id}/messages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: supportMessageCreateRequest, signal
    },
      options);
    }
  


export const getSupportSendMessageMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportSendMessage>>, TError,{id: string;data: SupportMessageCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof supportSendMessage>>, TError,{id: string;data: SupportMessageCreateRequest}, TContext> => {

const mutationKey = ['supportSendMessage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportSendMessage>>, {id: string;data: SupportMessageCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportSendMessage(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportSendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof supportSendMessage>>>
    export type SupportSendMessageMutationBody = SupportMessageCreateRequest
    export type SupportSendMessageMutationError = ErrorResponse

    /**
 * @summary Send support message
 */
export const useSupportSendMessage = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportSendMessage>>, TError,{id: string;data: SupportMessageCreateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportSendMessage>>,
        TError,
        {id: string;data: SupportMessageCreateRequest},
        TContext
      > => {

      const mutationOptions = getSupportSendMessageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List support messages
 */
export const supportListMessages = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SupportMessage[]>(
      {url: `/api/support/tickets/${id}/messages`, method: 'GET', signal
    },
      options);
    }
  



export const getSupportListMessagesQueryKey = (id?: string,) => {
    return [
    `/api/support/tickets/${id}/messages`
    ] as const;
    }

    
export const getSupportListMessagesQueryOptions = <TData = Awaited<ReturnType<typeof supportListMessages>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSupportListMessagesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof supportListMessages>>> = ({ signal }) => supportListMessages(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof supportListMessages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SupportListMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof supportListMessages>>>
export type SupportListMessagesQueryError = ErrorResponse


export function useSupportListMessages<TData = Awaited<ReturnType<typeof supportListMessages>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListMessages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportListMessages>>,
          TError,
          Awaited<ReturnType<typeof supportListMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportListMessages<TData = Awaited<ReturnType<typeof supportListMessages>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListMessages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supportListMessages>>,
          TError,
          Awaited<ReturnType<typeof supportListMessages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSupportListMessages<TData = Awaited<ReturnType<typeof supportListMessages>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List support messages
 */

export function useSupportListMessages<TData = Awaited<ReturnType<typeof supportListMessages>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof supportListMessages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSupportListMessagesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Mark all ticket messages read
 */
export const supportMarkTicketRead = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OkResponse>(
      {url: `/api/support/tickets/${id}/read`, method: 'POST', signal
    },
      options);
    }
  


export const getSupportMarkTicketReadMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMarkTicketRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof supportMarkTicketRead>>, TError,{id: string}, TContext> => {

const mutationKey = ['supportMarkTicketRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportMarkTicketRead>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  supportMarkTicketRead(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportMarkTicketReadMutationResult = NonNullable<Awaited<ReturnType<typeof supportMarkTicketRead>>>
    
    export type SupportMarkTicketReadMutationError = ErrorResponse

    /**
 * @summary Mark all ticket messages read
 */
export const useSupportMarkTicketRead = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMarkTicketRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportMarkTicketRead>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSupportMarkTicketReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Mark support message read
 */
export const supportMarkMessageRead = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OkResponse>(
      {url: `/api/support/messages/${id}/read`, method: 'POST', signal
    },
      options);
    }
  


export const getSupportMarkMessageReadMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMarkMessageRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof supportMarkMessageRead>>, TError,{id: string}, TContext> => {

const mutationKey = ['supportMarkMessageRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportMarkMessageRead>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  supportMarkMessageRead(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportMarkMessageReadMutationResult = NonNullable<Awaited<ReturnType<typeof supportMarkMessageRead>>>
    
    export type SupportMarkMessageReadMutationError = ErrorResponse

    /**
 * @summary Mark support message read
 */
export const useSupportMarkMessageRead = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportMarkMessageRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportMarkMessageRead>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSupportMarkMessageReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update support ticket
 */
export const supportUpdateTicket = (
    id: string,
    supportTicketUpdateRequest: SupportTicketUpdateRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<OkResponse>(
      {url: `/api/admin/support/tickets/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: supportTicketUpdateRequest
    },
      options);
    }
  


export const getSupportUpdateTicketMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportUpdateTicket>>, TError,{id: string;data: SupportTicketUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof supportUpdateTicket>>, TError,{id: string;data: SupportTicketUpdateRequest}, TContext> => {

const mutationKey = ['supportUpdateTicket'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof supportUpdateTicket>>, {id: string;data: SupportTicketUpdateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  supportUpdateTicket(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SupportUpdateTicketMutationResult = NonNullable<Awaited<ReturnType<typeof supportUpdateTicket>>>
    export type SupportUpdateTicketMutationBody = SupportTicketUpdateRequest
    export type SupportUpdateTicketMutationError = ErrorResponse

    /**
 * @summary Update support ticket
 */
export const useSupportUpdateTicket = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof supportUpdateTicket>>, TError,{id: string;data: SupportTicketUpdateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof supportUpdateTicket>>,
        TError,
        {id: string;data: SupportTicketUpdateRequest},
        TContext
      > => {

      const mutationOptions = getSupportUpdateTicketMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    